import React, {useEffect} from 'react';
import clsx from "clsx";
import TabsParameters from '../../../../Services/TabsParameters';

const ServiceRequestParams = (props) => {

    const {
        clickedEdit,
        annotationName,
        attributeTypeService,
        queryParams,
        setQueryParams,
        headers,
        setHeaders,
        bodyParams,
        setBodyParams
    } = props;


    useEffect( () => {
        if(attributeTypeService !== 'none'){
            const selectedProject = JSON.parse(localStorage.getItem('selectedProject'));
            const selectedService = JSON.parse(localStorage.getItem('data'))[selectedProject].services[0].services_requests.filter( service => service.name === attributeTypeService).map(service => service)[0];
            const selectedAnnotation = JSON.parse(localStorage.getItem('data'))[selectedProject].annotations[0] !== undefined ? JSON.parse(localStorage.getItem('data'))[selectedProject].annotations[0].combinations.filter( comb => comb.annotationName === annotationName).map( comb => comb)[0] : undefined;
            if( selectedAnnotation !== undefined && attributeTypeService !== selectedAnnotation.attributeTypeService){    
                setHeaders(selectedService.headers);
                setQueryParams(selectedService.query_par);
                setBodyParams(selectedService.body_par);
            }
            else if( selectedAnnotation !== undefined && selectedAnnotation.serviceParams.headers !== null){
                setHeaders(selectedAnnotation.serviceParams.headers);
                setQueryParams(selectedAnnotation.serviceParams.queryParams);
                setBodyParams(selectedAnnotation.serviceParams.bodyParams);
            }
            else{
                setHeaders(selectedService.headers);
                setQueryParams(selectedService.query_par);
                setBodyParams(selectedService.body_par);
            }
              
        }
    },[attributeTypeService, clickedEdit])

    return (
        <div className={clsx('spacingTopDiv')} >

            <TabsParameters
                headers={headers}
                setHeaders={setHeaders}
                params={queryParams}
                setParams={setQueryParams}
                bodyParams={bodyParams}
                setBodyParams={setBodyParams}
            />
        </div>
    )
}

export default ServiceRequestParams;